import classNames from "classnames";
// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
import * as appRouting from "appRouting";
// 
import * as Actions from "external/reports/officeStats/actions";
import FeedStatsReportView from "external/reports/officeStats/ui/FeedStatsReportView";
import FeedLeadsReportView from "external/reports/officeStats/ui/FeedLeadsReportView";
import { MaintenanceMessageBlock } from "common/ui/components/error/MaintenanceMessageBlock";
// Bootstrap
import { Button } from "react-bootstrap";
import { SimpleErrorBlock } from "common/ui/components/error/SimpleErrorBlock";
import { Loading } from "common/ui/loading/Loading";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./ExternalFeedOfficeView.less";
const mapStateToProps = (state) => ({
    officeData: state.external.reports.officeData,
    external: state.external.container
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch),
    dispatch: dispatch
});
var AppPageStateToRender;
(function (AppPageStateToRender) {
    AppPageStateToRender[AppPageStateToRender["FetchingUserData"] = 0] = "FetchingUserData";
    AppPageStateToRender[AppPageStateToRender["NotAuthenticated"] = 1] = "NotAuthenticated";
    AppPageStateToRender[AppPageStateToRender["NotAuthorised"] = 2] = "NotAuthorised";
    AppPageStateToRender[AppPageStateToRender["UnderMaintenance"] = 3] = "UnderMaintenance";
    AppPageStateToRender[AppPageStateToRender["TokenTimeout"] = 4] = "TokenTimeout";
    AppPageStateToRender[AppPageStateToRender["Error"] = 5] = "Error";
    AppPageStateToRender[AppPageStateToRender["Contents"] = 6] = "Contents";
})(AppPageStateToRender || (AppPageStateToRender = {}));
//-- Component -------------------------------------------------------------------------------------------------------------------------------
class ExternalFeedOfficeView extends React.Component {
    constructor(props) {
        super(props);
        //-- Click handlers -----------------
        this.onLoginClick = () => { appRouting.loginNavigate(this.props.dispatch); };
        this.onRetryClick = () => { location.href = location.href; };
        this.onHomeClick = () => { appRouting.homeNavigate(this.props.dispatch); };
        this.renderReport = () => {
            let officeId = this.props.officeData.officeId;
            if (this.state.page == 1) {
                return React.createElement(FeedStatsReportView, { officeId: officeId });
            }
            else {
                return React.createElement(FeedLeadsReportView, { officeId: officeId });
            }
        };
        this.renderContents = () => {
            return (React.createElement("div", { className: styles.container },
                React.createElement(Button, { className: classNames(this.state.page == 1 && styles.buttonSelected, this.state.page != 1 && styles.buttonUnselected), onClick: () => this.setState({ page: 1 }) }, "Stats"),
                React.createElement(Button, { className: classNames(this.state.page == 2 && styles.buttonSelected, this.state.page != 2 && styles.buttonUnselected), onClick: () => this.setState({ page: 2 }) }, "Leads"),
                this.renderReport()));
        };
        this.state = { page: 1 };
    }
    componentDidMount() {
        feedMode = true;
        feedapikey = this.props.params.feedapikey;
        feedToken = this.props.location.query.token;
        feedOfficeGuid = this.props.params.guid;
        this.props.actions.getOfficeData(this.props.params.guid);
    }
    //-- Render Helpers -----------------
    renderFetchingUserData() {
        return React.createElement(Loading, null);
    }
    renderNotAuthenticated() {
        return React.createElement(SimpleErrorBlock, { title: "Authentication failed." });
    }
    renderNotAuthorised() {
        return React.createElement(SimpleErrorBlock, { title: "You are not authorised to view this page." });
    }
    renderTokenTimeout() {
        return React.createElement(SimpleErrorBlock, { title: "Your access time has expired.", subTitle: "Please try refreshing your page." });
    }
    renderError() {
        return React.createElement(SimpleErrorBlock, { title: "An error occurred fetching your data." });
    }
    renderUnderMaintenance() {
        return React.createElement(MaintenanceMessageBlock, { title: "Insights will be back soon", subTitle: this.props.external.underMaintenanceMessage, buttonText: "Try Again", buttonCallback: () => this.onRetryClick() });
    }
    getPageStateToRender() {
        let { external } = this.props;
        if (external.isFetchingData) {
            return AppPageStateToRender.FetchingUserData;
        }
        else if (!external.isAuthenticatedToView) {
            return AppPageStateToRender.NotAuthenticated;
        }
        else if (!external.isAuthorisedToView) {
            return AppPageStateToRender.NotAuthorised;
        }
        else if (!external.isTokenTimeValid) {
            return AppPageStateToRender.TokenTimeout;
        }
        else if (external.isErrorView) {
            return AppPageStateToRender.Error;
        }
        else if (external.isUnderMaintenanceView) {
            return AppPageStateToRender.UnderMaintenance;
        }
        else {
            return AppPageStateToRender.Contents;
        }
    }
    //-- Render --------------------------
    render() {
        switch (this.getPageStateToRender()) {
            case AppPageStateToRender.FetchingUserData: return this.renderFetchingUserData();
            case AppPageStateToRender.NotAuthenticated: return this.renderNotAuthenticated();
            case AppPageStateToRender.NotAuthorised: return this.renderNotAuthorised();
            case AppPageStateToRender.TokenTimeout: return this.renderTokenTimeout();
            case AppPageStateToRender.Error: return this.renderError();
            case AppPageStateToRender.UnderMaintenance: return this.renderUnderMaintenance();
            case AppPageStateToRender.Contents: return this.renderContents();
            default: return this.renderError();
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ExternalFeedOfficeView);
